import Attachment from "../../caseLawDocuments/model/Attachment";
import { formatBooleanValue } from "../../util";
import CaseDecision from "../model/CaseDecision";

const CaseDecisionMapper = (item: any) => {
  let caseDecision = CaseDecision(item);
  caseDecision.valid = formatBooleanValue(item?.valid);
  caseDecision.attachment = Attachment(item?.attachment);
  return caseDecision;
};

export default CaseDecisionMapper;
